import {
  BILLINGPOC
} from "./type";

const initalState = {
  billingAddressPoc: [],
};

const clientReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case BILLINGPOC:
      return {
        ...state,
        billingAddressPoc: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default clientReducer;
